.amount {
  display: inline-flex;
  align-items: center;
  gap: 0.3em;
  white-space: nowrap;
  vertical-align: middle;
}

.coin {
  flex: none;
}
